import React from 'react';

import FooterLogoDesktop from '@/assets/images/FooterLogoDesktop.svg';
import FooterLogoMobile from '@/assets/images/FooterLogoMobile.svg';

import { useWindowSize } from '@/helpers/useWidth';

import { triggerGTAGButtonEvent } from '@/utils/analyticTracks';
import { localStorageSet } from '@/utils/localStorage';

import {
  Wrapper,
  Description,
  LogoContainer,
  StylesImage,
  LogoutButton,
} from './HomeFooter.styles';

const HomeFooter: React.FC = () => {
  const { width } = useWindowSize();
  const isDesktop = width > 768;
  const handleLogOut = () => {
    triggerGTAGButtonEvent('Log Out');
    localStorageSet('jwt', null);
    localStorageSet('user', false);
    localStorageSet('playPopUp', true);

    window.location.href = `${process.env.REACT_APP_URL_GAMEZONE}`;
  };
  return (
    <Wrapper>
      <LogoContainer>
        <StylesImage
          alt='logo'
          src={isDesktop ? FooterLogoDesktop : FooterLogoMobile}
        />
        {isDesktop && (
          <LogoutButton onClick={handleLogOut}>Log Out</LogoutButton>
        )}
      </LogoContainer>
      <div style={{ paddingTop: '10px' }}>
        {isDesktop ? (
          <Description style={{ display: 'block', textAlign: 'center' }}>
            © Copyright 1994 – 2024 ATP Tour, Inc. All Rights Reserved.
            <br /> No part of this site may be reproduced, stored in a retrieval
            system or transmitted in any way or by any means
            <br /> (including photocopying, recording or storing it in any
            medium by electronic means), without the written permission of ATP
            Tour, Inc.. <br />
            Terms & Conditions Privacy Modern Slavery Statement Feedback
          </Description>
        ) : (
          <Description style={{ display: 'block', textAlign: 'center' }}>
            © Copyright 1994 – 2024 ATP Tour, Inc. All Rights Reserved. No part
            of this site may be reproduced, stored in a retrieval system or
            transmitted in any way or by any means (including photocopying,
            recording or storing it in any medium by electronic means), without
            the written permission of ATP Tour, Inc..
          </Description>
        )}
      </div>
    </Wrapper>
  );
};

export default HomeFooter;
